// Contrato de status de campanha (fonte única no frontend).
//
// O backend agora entrega o status CRU (enum) em `campaign_status` /
// `campaign_status_raw` / `status`, e um rótulo já traduzido em
// `campaign_status_label` / `status_label`. Toda LÓGICA/comparação usa o enum;
// toda EXIBIÇÃO usa o label do payload ou, quando derivada localmente (badge em
// tempo real, agrupamento, filtro client-side), o i18n do frontend.

export const CAMPAIGN_STATUS = {
  SCHEDULED: 'scheduled',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

// Status terminais (campanha encerrada — não há mais progresso).
export const FINAL_CAMPAIGN_STATUSES = [
  CAMPAIGN_STATUS.COMPLETED,
  CAMPAIGN_STATUS.FAILED,
  CAMPAIGN_STATUS.CANCELLED,
];

const STATUS_I18N_KEY = {
  [CAMPAIGN_STATUS.SCHEDULED]: 'CAMPAIGN.STATUS_BADGE.SCHEDULED',
  [CAMPAIGN_STATUS.RUNNING]: 'CAMPAIGN.STATUS_BADGE.RUNNING',
  [CAMPAIGN_STATUS.COMPLETED]: 'CAMPAIGN.STATUS_BADGE.COMPLETED',
  [CAMPAIGN_STATUS.FAILED]: 'CAMPAIGN.STATUS_BADGE.FAILED',
  [CAMPAIGN_STATUS.CANCELLED]: 'CAMPAIGN.STATUS_BADGE.CANCELLED',
};

// Normaliza para o enum cru. O contrato já entrega cru; isto é apenas defesa
// contra caixa/espaços. NÃO traduz — status desconhecido volta cru (nunca
// esconde: falha visível).
export function normalizeCampaignStatus(status) {
  if (!status) return null;
  return String(status).trim().toLowerCase();
}

// Rótulo de exibição derivado localmente. Enum conhecido → i18n; status
// desconhecido → valor cru (não degrada em silêncio).
export function campaignStatusLabel(status, t) {
  const normalized = normalizeCampaignStatus(status);
  const key = normalized ? STATUS_I18N_KEY[normalized] : null;
  return key ? t(key) : status || '';
}

export function isFinalCampaignStatus(status) {
  return FINAL_CAMPAIGN_STATUSES.includes(normalizeCampaignStatus(status));
}
